export default __webpack_public_path__ + "static/media/안정성.252a9bc0.png";